import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/node/app/node_modules/next/node_modules/@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { ApolloProvider, getDataFromTree } from 'react-apollo';
import initApollo from "../data/apollo";
import logger from "../utils/logger";
var getComponentDisplayName = function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || 'Unknown';
};
var withApollo = function withApollo(ComposedComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_React$Component) {
    function WithData(props) {
      var _this;
      _classCallCheck(this, WithData);
      _this = _callSuper(this, WithData, [props]);
      _this.apollo = initApollo(_this.props.serverState.apollo.data);
      return _this;
    }
    _inherits(WithData, _React$Component);
    return _createClass(WithData, [{
      key: "render",
      value: function render() {
        return __jsx(ApolloProvider, {
          client: this.apollo
        }, __jsx(ComposedComponent, _extends({}, this.props, {
          apolloClient: this.apollo
        })));
      }
    }], [{
      key: "getInitialProps",
      value: function () {
        var _getInitialProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
          var router, serverState, composedInitialProps, apollo;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  router = ctx.router; // Initial serverState with apollo (empty)
                  serverState = {}; // Evaluate the composed component's getInitialProps()
                  composedInitialProps = {};
                  if (!ComposedComponent.getInitialProps) {
                    _context.next = 7;
                    break;
                  }
                  _context.next = 6;
                  return ComposedComponent.getInitialProps(ctx);
                case 6:
                  composedInitialProps = _context.sent;
                case 7:
                  // Run all GraphQL queries in the component tree
                  // and extract the resulting data
                  apollo = initApollo();
                  _context.prev = 8;
                  _context.next = 11;
                  return getDataFromTree(__jsx(ComposedComponent, _extends({
                    router: router
                  }, composedInitialProps)), {
                    client: apollo
                  });
                case 11:
                  _context.next = 16;
                  break;
                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](8);
                  // Prevent Apollo Client GraphQL errors from crashing SSR.
                  // Handle them in components via the data.error prop:
                  // https://www.apollographql.com/docs/react/basics/queries.html#graphql-query-data-error
                  if (!process.browser) {
                    logger.error("[Apollo SSR error]: ".concat(_context.t0));
                  }
                case 16:
                  // Extract query data from the Apollo store
                  serverState = {
                    apollo: {
                      data: apollo.cache.extract()
                    }
                  };
                  return _context.abrupt("return", _objectSpread({
                    serverState: serverState
                  }, composedInitialProps));
                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[8, 13]]);
        }));
        function getInitialProps(_x) {
          return _getInitialProps.apply(this, arguments);
        }
        return getInitialProps;
      }()
    }]);
  }(React.Component), _class.displayName = "WithData(".concat(getComponentDisplayName(ComposedComponent), ")"), _class;
};
export default withApollo;